export const getStoryblokStoryVersion = () => {
  return process.env.NEXT_PUBLIC_STORYBLOK_ENV === 'production'
    ? 'published'
    : 'draft'
}
